module.exports = "<uch></uch>\r\n<head-title params='title:\"我的足迹\"'></head-title>\r\n<track-item></track-item>";


//////////////////
// WEBPACK FOOTER
// ./src/component/track/trackIndex.html
// module id = 214
// module chunks = 0